import React, { useEffect } from 'react';
import qs from 'qs';
import { useSelector, useDispatch } from 'react-redux';

import InvitationSuccess from './InvitationSuccess';
import InvitationError from './InvitationError';
import { selectCurrentUser } from '../../../store/modules/users/selectors';
import { selectAuthRoot } from '../../../store/modules/auth/selectors';
import { logOut } from '../../../store/modules/auth/actions';
import { setRouterPreventRedirect, setInvitation } from '../../../store/modules/app/actions';


const InvitationPage = () => {
  const dispatch = useDispatch();
  const queryData = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  const { data: currentUser } = useSelector(selectCurrentUser);
  const { tokens, loading: initAuth } = useSelector(selectAuthRoot);
  const accepted = queryData.accepted === '1';
  const register = queryData.new_user === '1';
  const { error, email } = queryData;

  useEffect(() => {
    if (!error) {
      dispatch(setRouterPreventRedirect(true));
      dispatch(setInvitation({ email }));
      if (!initAuth && tokens.access !== null) {
        if (currentUser) {
          if (email && currentUser.email !== email) {
            dispatch(logOut());
          } else {
            dispatch(setInvitation(null));
          }
        }
      }
    }

    return () => {
      dispatch(setRouterPreventRedirect(false));
    };
  }, [dispatch, error, currentUser, email, initAuth, tokens]);

  if (error) {
    return (
      <InvitationError message={error} />
    );
  }

  return (
    <InvitationSuccess accepted={accepted} register={register} auth={Boolean(currentUser)} />
  );
};

export default InvitationPage;
